module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 text-xs-center"
  }, [_vm._v(_vm._s(_vm.alert.alertName))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsCreator) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-alert-dialog', {
    attrs: {
      "alert": _vm.alert
    }
  })] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dbc27e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert/Alert.vue
// module id = 664
// module chunks = 1